<template>
  <v-container class="pt-0" fluid>
    <v-row align="center">
      <v-col cols="12">
        <tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAllAnalisesBp()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAllAnalisesBp())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AnalisesBancoPrecosService from '@/services/AnalisesBancoPrecosService';
  import pusherMixins from '@/mixins/pusherMixins';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Tabela: () => import('@/components/analisesBancoPrecos/Tabela.vue')
    },
    mixins: [pusherMixins, tourMixins],

    data: () => ({
      items: [],
      loading: false,
      processamentosExpirados: false,
      arrTour: [
        {
          element: '#btn-nova-analise-bp',
          intro: 'Clicando neste botão você poderá criar novas Análises de Banco de Preços.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#analise-bp-search',
          intro: 'Neste campo você poderá pesquisar por Análises de Banco de Preços já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-download-analise-bp',
          intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado de sua Análise de Banco de Preços.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-edit-analise-bp',
          intro: 'Clicando neste ícone você poderá editar sua Análise de Banco de Preços.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-more-analise-bp',
          intro:
            'Aqui você acessa outras opções para sua Análise de Banco de Preços, como ver mais detalhes, executá-lo novamente ou deletá-lo.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    created() {
      this.getAllAnalisesBp();
    },

    mounted() {
      this.subscribe();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('reload-pag-analises-bp', () => {
          this.getAllAnalisesBp();
        });
      },

      getAllAnalisesBp() {
        this.loading = true;

        AnalisesBancoPrecosService.getAllAnalisesBp(this.processamentosExpirados)
          .then((resp) => (this.items = resp.data.data))
          .catch((err) => {
            this.$toast.error('Erro ao recuperar as Análises de Banco de Preços Cadastradas.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
            this.iniciarTourPagina();
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>